import { createSelector } from '@reduxjs/toolkit';
import menusSelector from './menus';

const showSidebarMenuSelector = createSelector(menusSelector, (menus) => menus.showSidebar);

export default showSidebarMenuSelector;
